module.exports = (__webpack_require__(14))(30);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/object-assign/index.js from dll-reference vendor_library
// module id = 295
// module chunks = 0